"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgBtDownload = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgBtDownload = function SvgBtDownload(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.5416 14.229C21.2869 14.229 21.0832 14.4328 21.0832 14.6874V18.8572C21.0832 19.9914 20.1596 20.9116 19.0289 20.9116H8.97114C7.83701 20.9116 6.91681 19.988 6.91681 18.8572V14.6195C6.91681 14.3649 6.71307 14.1611 6.4584 14.1611C6.20374 14.1611 6 14.3649 6 14.6195V18.8572C6 20.4973 7.33447 21.8284 8.97114 21.8284H19.0289C20.6689 21.8284 22 20.4939 22 18.8572V14.6874C22 14.4362 21.7963 14.229 21.5416 14.229Z",
    fill: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.6778 18.1885C13.766 18.2767 13.8849 18.3243 14.0003 18.3243C14.1158 18.3243 14.2346 18.2801 14.3229 18.1885L17.2363 15.275C17.4163 15.0951 17.4163 14.8065 17.2363 14.6265C17.0564 14.4465 16.7677 14.4465 16.5878 14.6265L14.4587 16.7589V7.4584C14.4587 7.20374 14.255 7 14.0003 7C13.7457 7 13.5419 7.20374 13.5419 7.4584V16.7589L11.4095 14.6265C11.2295 14.4465 10.9409 14.4465 10.761 14.6265C10.581 14.8065 10.581 15.0951 10.761 15.275L13.6778 18.1885Z",
    fill: "currentColor"
  }));
};

exports.SvgBtDownload = SvgBtDownload;